import React, { useEffect } from "react";
import "./IndustryExpertiseIntro.css";
import { Link } from "react-router-dom";

import projectBg from "../../images/bg/project-bg.png";

import projectImg01 from "../../images/project/project-img01.jpg";
import projectImg02 from "../../images/project/project-img02.jpg";
import projectImg03 from "../../images/project/project-img03.jpg";
import projectImg04 from "../../images/project/project-img04.jpg";
import projectImg05 from "../../images/project/project-img05.jpg";
import projectImg06 from "../../images/project/project-img06.jpg";

import icon01 from "../../images/icon/defence.png";
import icon02 from "../../images/icon/project-icon02.svg";
import icon03 from "../../images/icon/project-icon03.svg";
import icon08 from "../../images/icon/project-icon08.svg";
import icon09 from "../../images/icon/project-icon09.svg";
import icon10 from "../../images/icon/project-icon10.svg";
import icon11 from "../../images/icon/project-icon11.svg";
import icon12 from "../../images/icon/project-icon12.svg";
import icon13 from "../../images/icon/project-icon13.svg";

interface IndustryItem {
  id: number;
  img: string;
  title: string;
  desc: string;
  industry: string;
  expertise: string;
  techs: string[];
  link: string;
}

const industries: IndustryItem[] = [
  {
    id: 1,
    img: projectImg01,
    title: "AI & High-Performance Compute",
    desc:
      "Engineering solutions for high-performance processing, advanced computing architectures and next-generation AI applications.",
    industry: "AI & High-Performance Compute",
    expertise:
      "AI accelerators, compute-intensive SoCs, advanced processors and high-performance silicon",
    techs: [icon01, icon02, icon03],
    link: "/service-details",
  },
  {
    id: 2,
    img: projectImg02,
    title: "Networking & Communication",
    desc:
      "Supporting high-speed connectivity, communication infrastructure, networking devices and data movement technologies.",
    industry: "Networking & Communication",
    expertise:
      "Ethernet, SerDes, protocol processing, connectivity silicon and communication infrastructure",
    techs: [icon01, icon08, icon09],
    link: "/service-details",
  },
  {
    id: 3,
    img: projectImg03,
    title: "Storage & Memory",
    desc:
      "Engineering expertise for memory technologies, storage controllers, high-speed interfaces and data-centric applications.",
    industry: "Storage & Memory",
    expertise:
      "Storage controllers, memory subsystems, DDR, HBM and high-speed interfaces",
    techs: [icon10, icon11, icon01],
    link: "/service-details",
  },
  {
    id: 4,
    img: projectImg04,
    title: "Automotive",
    desc:
      "Supporting semiconductor development for ADAS, autonomous systems, vehicle electronics, functional safety and next-generation mobility.",
    industry: "Automotive",
    expertise:
      "ADAS, autonomous systems, EV platforms, vehicle electronics and functional safety",
    techs: [icon08, icon12, icon13],
    link: "/service-details",
  },
  {
    id: 5,
    img: projectImg05,
    title: "Defence",
    desc:
      "Engineering support for mission-critical, secure and high-reliability semiconductor applications.",
    industry: "Defence",
    expertise:
      "Secure systems, high-reliability silicon and mission-critical semiconductor platforms",
    techs: [icon02, icon10, icon12],
    link: "/service-details",
  },
  {
    id: 6,
    img: projectImg06,
    title: "Consumer & Industrial Electronics",
    desc:
      "Delivering engineering capabilities for embedded systems, industrial automation, IoT devices and consumer technologies.",
    industry: "Consumer & Industrial Electronics",
    expertise:
      "Embedded systems, industrial automation, IoT platforms and connected consumer devices",
    techs: [icon03, icon09, icon13],
    link: "/service-details",
  },
];

const IndustryExpertise: React.FC = () => {
  useEffect(() => {
    const backgroundElement =
      document.querySelector<HTMLElement>(".industry-expertise.bg_img");

    if (backgroundElement) {
      backgroundElement.style.backgroundImage = `url(${projectBg})`;
    }

    const items = document.querySelectorAll<HTMLElement>(
      ".industry-expertise .xb-project-item"
    );

    const paginationItems = document.querySelectorAll<HTMLElement>(
      ".industry-expertise .xb-project-pagination li"
    );

    if (!items.length || !paginationItems.length) {
      return;
    }

    items.forEach((item) => {
      item.style.transition = "opacity 0.6s ease";
      item.style.opacity = "1";
    });

    const updateActiveIndustry = () => {
      let activeIndex = 0;
      const triggerLine = window.innerHeight * 0.3;

      items.forEach((item, index) => {
        const rect = item.getBoundingClientRect();

        if (rect.top <= triggerLine) {
          activeIndex = index;
        }
      });

      paginationItems.forEach((item) => {
        item.classList.remove("active");
      });

      paginationItems[activeIndex]?.classList.add("active");

      items.forEach((item, index) => {
        item.style.opacity =
          index === activeIndex || index > activeIndex ? "1" : "0.3";
      });
    };

    window.addEventListener("scroll", updateActiveIndustry);
    updateActiveIndustry();

    return () => {
      window.removeEventListener("scroll", updateActiveIndustry);
    };
  }, []);

  const ArrowIcon = () => (
    <>
      {[0, 1].map((index) => (
        <svg
          key={index}
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <rect
            x="5.06592"
            y="19.9785"
            width="20.5712"
            height="2.61221"
            transform="rotate(-40.2798 5.06592 19.9785)"
            fill="white"
          />
          <rect
            x="7.97095"
            y="7.24463"
            width="2.61221"
            height="2.61221"
            transform="rotate(-40.2798 7.97095 7.24463)"
            fill="white"
          />
          <rect
            x="11.6523"
            y="7.54834"
            width="2.61221"
            height="2.61221"
            transform="rotate(-40.2798 11.6523 7.54834)"
            fill="white"
          />
          <rect
            x="15.334"
            y="7.85205"
            width="2.61221"
            height="2.61221"
            transform="rotate(-40.2798 15.334 7.85205)"
            fill="white"
          />
          <rect
            x="18.7119"
            y="11.8374"
            width="2.61221"
            height="2.61221"
            transform="rotate(-40.2798 18.7119 11.8374)"
            fill="white"
          />
          <rect
            x="18.4084"
            y="15.52"
            width="2.61221"
            height="2.61221"
            transform="rotate(-40.2798 18.4084 15.52)"
            fill="white"
          />
          <rect
            x="18.104"
            y="19.2012"
            width="2.61221"
            height="2.61221"
            transform="rotate(-40.2798 18.104 19.2012)"
            fill="white"
          />
        </svg>
      ))}
    </>
  );

  return (
    <section
      id="industry-expertise"
      className="project industry-expertise bg_img pt-135 pb-150"
    >
      <div className="industry-intro-container">
        <div className="industry-intro">
          <span className="sub-title">Industry Expertise</span>

          <h2 className="title">Industry Expertise</h2>

          <p className="industry-intro-copy">
            Semiconductor engineering demands a deep understanding of
            industry-specific requirements, application challenges and evolving
            technology landscapes. Digicomm Semiconductor supports engineering
            programs across diverse industry segments, delivering specialized
            expertise aligned with the technical and performance expectations
            of each domain.
          </p>

          <div className="xb-heading-btn d-inline">
            <Link className="thm-btn agency-btn" to="/service">
              <span className="text">Explore Industries</span>

              <span className="arrow">
                <span className="arrow-icon">
                  <ArrowIcon />
                </span>
              </span>
            </Link>
          </div>
        </div>
      </div>

      <div className="container mxw-1800">
        <div className="xb-project-wrap">
          <div className="xb-project-pagination-wrap">
            <ul className="xb-project-pagination">
              {industries.map((industry, index) => (
                <li
                  key={industry.id}
                  className={index === 0 ? "active" : ""}
                >
                  {index + 1}
                </li>
              ))}
            </ul>
          </div>

          <div className="xb-project-inner">
            {industries.map((industry) => (
              <div
                key={industry.id}
                className="xb-project-item bg_img"
                style={{
                  backgroundImage: `url(${industry.img})`,
                }}
              >
                <div className="xb-project-content">
                  <div className="xb-item--inner xb-border">
                    <h2 className="xb-item--title">{industry.title}</h2>

                    <p className="xb-item--content">{industry.desc}</p>

                    <ul className="xb-item--list ul_li">
                      <li>
                        Industry: <span>{industry.industry}</span>
                      </li>

                      <li>
                        Expertise: <span>{industry.expertise}</span>
                      </li>
                    </ul>

                    {/* Core Capabilities - Hidden

                    <div className="xb-item--technologie ul_li">
                      <span>Core Capabilities:</span>

                      <ul className="list-unstyled ul_li">
                        {industry.techs.map((icon, index) => (
                          <li key={index}>
                            <img
                              src={icon}
                              alt=""
                              aria-hidden="true"
                            />
                          </li>
                        ))}
                      </ul>
                    </div> */}

                    <div className="xb-item---btn mt-70">
                      <Link
                        className="thm-btn agency-btn"
                        to={industry.link}
                      >
                        <span className="text">Explore Industries</span>

                        <span className="arrow">
                          <span className="arrow-icon">
                            <ArrowIcon />
                          </span>
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustryExpertise;